package org.hs_soft.runmynesto.data.api_datasource.home

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.home.hssoft_apps_list.HSSoftAppsModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.home.HSSoftAppsRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.config.Errors


class HSSoftAppsRepositoryImpl (
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): HSSoftAppsRepository {
    
    private var abortController: AbortController? = null

    override suspend fun getHSSoftApps(): HSSoftAppsModel {
        abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put(
                "query", """
                   query listHSWebApps {
                     listHSWebApps {
                       appType
                       isAvailable
                     }
                   }
                """.trimIndent()
            )


        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController!!,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }

    override fun cancel() {
        abortController?.abort()
        abortController = null
    }
}

